import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Base, Especialidade } from "app/models/especialidade";
import { EspecialidadePorEncaminhamento } from 'app/models/restricao-especialidade';
import { TeleconsultaEspecialidadePorEncaminhamentoRequest } from 'app/models/teleconsultaRestricaoEspecialidadeEncRequest';
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class RestricaoAgendamentoPresencialService {
   private API_URL: string = environment.apiUrl;

   constructor(
      private http: Http,
   ) { }

   obterRestricoesEspecialidadeEncaminhamento(): Observable<EspecialidadePorEncaminhamento[]> {
      return this.http.get(this.API_URL + 'AgendamentoPresencialEspecialidadeEncaminhamento')
         .map(
            response => response.json(),
            error => error.json()
         );
   }

   obterEspecialidades(): Observable<Base<Especialidade[]>> {
      return this.http.get(this.API_URL + 'AgendamentoPresencialEspecialidadeEncaminhamentoController/ObterEspecialidades')
         .map(
            response => response.json(),
            error => error.json()
         );
   }

   public salvarRestricoesEspecialidadeEncaminhamento(data: TeleconsultaEspecialidadePorEncaminhamentoRequest) {
      const url = `${this.API_URL}AgendamentoPresencialEspecialidadeEncaminhamento`;
      return this.http.post(url, data).map(
         res => res.json(),
         error => error.json()
      );
   }

}



// WEBPACK FOOTER //
// ./src/app/app-services/restricao-agendamento-presencial.service.ts